import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import {appRoute} from '../../../../../app-route';
import {NavigationLink} from '../../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../../provider/locale/locale';
import {useSystem} from '../../../../../provider/system/system-hook';

export function AddReviewButton(): JSX.Element {
    const {screen} = useSystem();

    return (
        <NavigationLink isTargetBlank to={appRoute.reviewsManagementCreateReview.path}>
            <Button icon={screen.isMobile ? <FontAwesomeIcon icon={faPlus} /> : null} type="primary">
                {!screen.isMobile && <Locale stringKey="REVIEW__ADD_REVIEW__TOOLTIP" />}
            </Button>
        </NavigationLink>
    );
}
